"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.batch_save_elements_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const batch_update_elements_1 = require("../../../../api/calls/document/batch_update_elements");
const document_1 = require("../document");
const main_1 = require("../../main");
exports.batch_save_elements_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/batch_save_elements", (_, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { selectedDocument, selectedDocumentElements, pendingUpdates } = state.documentState;
    // Check if there are any pending updates
    const pendingElementIds = Object.keys(pendingUpdates);
    if (pendingElementIds.length === 0) {
        return { success: true, updated_count: 0 };
    }
    // Note: No loading indicator - save happens silently in background
    // Build array of elements to update by merging pending changes with current element data
    const elementsToUpdate = pendingElementIds
        .map((elementId) => {
        const currentElement = selectedDocumentElements.find((el) => el._id === elementId);
        const pendingUpdate = pendingUpdates[elementId];
        if (!currentElement) {
            return null;
        }
        // Merge current element with pending changes
        return Object.assign(Object.assign(Object.assign({}, currentElement), pendingUpdate.changes), { 
            // Merge extra_attributes separately to avoid overwriting
            extra_attributes: Object.assign(Object.assign({}, currentElement.extra_attributes), (pendingUpdate.changes.extra_attributes || {})) });
    })
        .filter(Boolean); // Remove nulls
    if (elementsToUpdate.length === 0) {
        return { success: true, updated_count: 0 };
    }
    // Call batch update API with loader: false for silent background save
    const response = yield (0, batch_update_elements_1.batch_update_elements)({
        document_id: selectedDocument._id,
        elements: elementsToUpdate,
    }, false);
    if (response.success) {
        // Clear pending updates after successful save
        dispatch((0, document_1.clearAllPendingUpdates)());
        return response.content;
    }
    else {
        dispatch((0, main_1.setMessageModal)({
            title: "Save Failed",
            messages: [response.message || "Failed to save changes"],
        }));
        return null;
    }
}));
